// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__Z7VjQ","clickable":"Table_clickable__3YM0B","easyTable":"Table_easyTable__MqeH3"};